import useLenis from "../hooks/useLenis";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import Films from "../components/Films";
import Packages from "../components/Packages";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import InstagramStrip from "../components/InstagramStrip";
import BookingForm from "../components/BookingForm";
import Footer from "../components/Footer";
import StickyWhatsApp from "../components/StickyWhatsApp";

export default function Landing() {
  useLenis();

  return (
    <div className="bg-ink text-ivory font-body min-h-screen overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Portfolio />
        <Films />
        <Packages />
        <WhyChooseUs />
        <Testimonials />
        <InstagramStrip />
        <BookingForm />
      </main>
      <Footer />
      <StickyWhatsApp />
    </div>
  );
}
